import type { VeeraContextualThreadEntrySurface, VeeraContextualThreadRole } from "@/lib/veeraContextualThreads";

export interface VeeraThreadTitleInput {
  role: VeeraContextualThreadRole;
  entrySurface: VeeraContextualThreadEntrySurface;
  actionTitle?: string | null;
  patternTitle?: string | null;
  lessonTitle?: string | null;
  topicTitle?: string | null;
  leaderName?: string | null;
}

function normalizeTitle(value: string | null | undefined, fallback = "New conversation") {
  const normalized = value?.replace(/\s+/g, " ").trim();
  return normalized ? normalized : fallback;
}

function normalizeLeaderName(value: string | null | undefined) {
  const normalized = value?.replace(/\s+/g, " ").trim();
  return normalized ? normalized : null;
}

export function buildVeeraThreadTitle(params: VeeraThreadTitleInput) {
  if (params.role === "coach") {
    const topicTitle = normalizeTitle(params.topicTitle);
    const leaderName = normalizeLeaderName(params.leaderName);
    return params.entrySurface === "portfolio"
      ? topicTitle
      : leaderName
        ? `${leaderName}: ${topicTitle}`
        : topicTitle;
  }

  switch (params.entrySurface) {
    case "today":
      return normalizeTitle(params.actionTitle ?? params.topicTitle);
    case "insights":
      return normalizeTitle(params.patternTitle ?? params.topicTitle);
    case "reflection":
      return normalizeTitle(params.lessonTitle ?? params.topicTitle);
    default:
      return normalizeTitle(params.topicTitle);
  }
}
